<template>
  <div>
    <!-- 第一部分 -->
    <div class="banner">
      <img
        src="../assets/banner-aboutus.png"
        alt=""
        style="vertical-align: middle; width: 100%"
      />
    </div>

    <div class="first_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">集团简介</span>
              <span class="title_en"> Group Introduction </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex j-center">
        <div style="width: 1200px; text-align: left">
          <p style="font-size: 20px; color: #333; line-height: 1.75em">
            品谱集团总部位于美国威斯康辛州麦迪逊，是财富美国500强企业之一，同时也是纽约证券交易所上市公司。
          </p>
          <div style="width: 1200px; height: 80px; background-color: #2963a4;padding: 0 30px;box-sizing: border-box;margin-top: 30px;">
            <span style="font-size: 28px; font-weight: 600; color: #fff;line-height: 80px;letter-spacing: 1.2px">
              愿景:成为具有卓越价值的日用消费品全球领导者
              </span>
          </div>
          <div style="width: 1200px; height: 80px; background-color: #2963a4;padding: 0 30px;box-sizing: border-box;margin: 30px 0;">
            <span style="font-size: 28px; font-weight: 600; color: #fff;line-height: 80px;letter-spacing: 1.2px">
                目标:通过红利的增长和债务的减少来创造股东的利益
              </span>
          </div>
          <div style="margin-bottom: 20px;">
            <span style="font-size: 28px; font-weight: 600; color: #333;letter-spacing: 1.2px">
                核心业务：
              </span>
          </div>
          <div>
            <img src="../assets/banner2-aboutus.png" alt="图片" style="width: 100%;vertical-align: middle;">
          </div>
        </div>
      </div>
    </div>

    <!-- 第二部分 -->
    <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">百年历程</span>
              <span class="title_en"> History of Centenary </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex j-center">
        <div style="width: 1200px; text-align: left">
          <p style="font-size: 20px; color: #333; line-height: 1.75em">
            Spectrum Brands Holdings 品谱控股集团是Russell罗素1000
            指数的成员之一，全球性消费品公司，提供不断扩大的卓越品牌，每天为全球消费者和客户创造卓越价值。
            <br />
          </p>
          <div style="width: 1200px; height: 80px; background-color: #67AE3E;padding: 0 30px;box-sizing: border-box;margin-top: 30px;">
            <span style="font-size: 28px; font-weight: 600; color: #fff;line-height: 80px;letter-spacing: 1.2px">
              · 提供家居日用的消费品
              </span>
          </div>
          <div style="width: 1200px; height: 80px; background-color: #67AE3E;padding: 0 30px;box-sizing: border-box;margin-top: 30px;">
            <span style="font-size: 28px; font-weight: 600; color: #fff;line-height: 80px;letter-spacing: 1.2px">
                · 具有进入专业细分市场类别的市场领导品牌
              </span>
          </div>
          <div style="width: 1200px; height: 80px; background-color: #67AE3E;padding: 0 30px;box-sizing: border-box;margin-top: 30px;">
            <span style="font-size: 28px; font-weight: 600; color: #fff;line-height: 80px;letter-spacing: 1.2px">
                · 为我们的客户与消费者提供卓越价值
              </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 第三部分 -->
    <div class="third_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">品牌价值</span>
              <span class="title_en"> Brand Value </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex j-center">
        <div style="width: 1200px; text-align: left">
            <div>
                <img src="../assets/banner3-aboutus.png" alt="" style="width: 100%;vertical-align: center;">
            </div>
          <div style="width: 1200px; height: 80px; background-color: #2963a4;padding: 0 30px;box-sizing: border-box;margin-top: 30px;">
            <span style="font-size: 28px; font-weight: 600; color: #fff;line-height: 80px;letter-spacing: 1.2px">
                · 纽交所上市公司
              </span>
          </div>
          <div style="width: 1200px; height: 80px; background-color: #2963a4;padding: 0 30px;box-sizing: border-box;margin-top: 30px;">
            <span style="font-size: 28px; font-weight: 600; color: #fff;line-height: 80px;letter-spacing: 1.2px">
                · 快速成长的消费品公司
              </span>
          </div>
          <div style="width: 1200px; height: 80px; background-color: #2963a4;padding: 0 30px;box-sizing: border-box;margin-top: 30px;">
            <span style="font-size: 28px; font-weight: 600; color: #fff;line-height: 80px;letter-spacing: 1.2px">
                · 战略性收购与自身成长
              </span>
          </div>
          <div style="width: 1200px; height: 80px; background-color: #2963a4;padding: 0 30px;box-sizing: border-box;margin-top: 30px;">
            <span style="font-size: 28px; font-weight: 600; color: #fff;line-height: 80px;letter-spacing: 1.2px">
                · 全球排名前25的零售商紧密合作
              </span>
          </div>
          <div style="width: 1200px; height: 80px; background-color: #2963a4;padding: 0 30px;box-sizing: border-box;margin-top: 30px;">
            <span style="font-size: 28px; font-weight: 600; color: #fff;line-height: 80px;letter-spacing: 1.2px">
                · 108个分支机构遍布全球55个国家和地区，12000员工
              </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 第四部分 -->
    <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">百年历程</span>
              <span class="title_en"> History of Centenary </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex" style="flex-direction: column;">
        <div style="margin-bottom: 40px;">
                <img src="../assets/banner5-aboutus.png" alt="" style="width: 100%;vertical-align: center;">
            </div>
            <div>
                <img src="../assets/banner4-aboutus.png" alt="" style="width: 100%;vertical-align: center;">
            </div>
      </div>
    </div>

    <!-- 第五部分 -->
    <div class="third_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">悠长历史</span>
              <span class="title_en"> Long History </span>
            </div>
          </div>
        </div>
      </div>
     <!-- 正文 -->
     <div class="w d-flex" style="flex-direction: column;">
        <div style="margin-bottom: 40px;">
                <img src="../assets/banner6-aboutus.png" alt="" style="width: 100%;vertical-align: center;">
            </div>
            <div>
                <img src="../assets/banner7-aboutus.png" alt="" style="width: 100%;vertical-align: center;">
            </div>
      </div>
    </div>

     <!-- 第六部分 -->
     <div class="second_part">
      <div class="w">
        <!-- 标题 -->
        <div class="title">
          <div class="titleBox">
            <!-- <div class="title_num">01</div> -->
            <div class="title_contain">
              <span class="title_intro">全球领先的宠物用品公司</span>
              <span class="title_en"> Popular Pet Products Company</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 正文 -->
      <div class="w d-flex" style="flex-direction: column;">
        <div style="width: 1200px; text-align: left">
          <p style="font-size: 20px; color: #333; line-height: 1.75em">
            品谱集团旗下有德彩，富美内特，天然奇迹，洁齿骨零食等多个全球领先的水族用品及宠物用品品牌，持续为为全球消费者和客户提供卓越价值。
          </p>
          </div>
        <div style="margin-top: 40px;">
                <img src="../assets/banner8-aboutus.png" alt="" style="width: 100%;vertical-align: center;">
            </div>
      </div>
    </div>


    <!-- 底部栏 -->
    <foot></foot>
  </div>
</template>
<script>
import foot from '@/components/footer.vue'
export default {
    data() {
        return {
            
        }
    },
    components:{
    foot
  },
};
</script>
<style lang="scss" scoped>
.w {
  width: 1200px;
  margin: 0 auto;
}

.d-flex {
  display: flex;
}
.a-center {
  align-items: center;
}

.j-center {
  justify-content: center;
}
.banner {
  width: 100%;
  margin-top: 0;
}
.first_part {
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}

.title {
  width: 1200px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.titleBox {
  padding: 4px 0;
  //   border-bottom: 1px solid #2963a4;
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  //   .title_num {
  //     font-size: 80px;
  //     font-weight: 500;
  //     color: #2963a4;
  //     margin-right: 5px;
  //   }
  .title_contain {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 20px;
    border-bottom: 5px solid #2963a4;
    .title_intro {
      font-size: 46px;
      color: #333;
      font-weight: 600;
      text-align: center;
    }
    .title_en {
      font-size: 35px;
      letter-spacing: 0.02em;
      text-align: center;
      color: #999;
    }
  }
}

.second_part{
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #fff;
}

.third_part{
  display: flex;
  justify-content: center;
  //   align-items: center;
  flex-direction: column;
  padding: 90px 0;
  background-color: #f4f7fb;
}
</style>